import { createAction, props } from '@ngrx/store';
import { ILocale } from '../../models/locale.model';

// reducer actions
export const setLocales = createAction('[Locale] SET LOCALES', props<{ locales: ILocale[] }>());
export const setLocaleId = createAction('[Locale] SET LOCALE ID', props<{ localeId: string }>());

// effect actions
export const setLocalesEffect = createAction('[Locale] SET LOCALES EFFECT', props<{ force: boolean }>());
